import { render } from "./px-steps.vue?vue&type=template&id=513e98a4&scoped=true&ts=true"
import script from "./px-steps.vue?vue&type=script&lang=ts"
export * from "./px-steps.vue?vue&type=script&lang=ts"

import "./px-steps.vue?vue&type=style&index=0&id=513e98a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513e98a4"]])

export default __exports__